import { createContext, useContext } from "react";

const SidebarContext = createContext({
  isSidebarOpen: true,
  openSidebar: () => {},
  closeSidebar: () => {},
  setSidebarOpen: () => {},
});

export function SidebarProvider({ children, value }) {
  return (
    <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
  );
}

export function useSidebar() {
  return useContext(SidebarContext);
}
